import styled from "styled-components";

export const CartItemContainer = styled.div`
  display: flex;
  width: 100%;
  height: 80px;
  padding: 15px 0;
  column-gap: 12px;
  border-bottom: 1px solid #cccccc;
`;

export const CartItemImg = styled.img`
  width: 20%;
`;

export const ItemDetails = styled.div`
  font-size: 0.8rem;
`;
